import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDPYqEu1vWhGBn3tDq9fYEr2kjDz9-j46k",
  authDomain: "clockinapp-200d0.firebaseapp.com",
  projectId: "clockinapp-200d0",
  storageBucket: "clockinapp-200d0.firebasestorage.app",
  messagingSenderId: "467202860404",
  appId: "1:467202860404:web:5b8cfc3006d55a0d713821"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Secondary app for creating users without logging out the admin
const secondaryApp = initializeApp(firebaseConfig, 'secondary');
export const secondaryAuth = getAuth(secondaryApp);

export const getCompanyId = async () => {
  const user = auth.currentUser;
  if (!user) return null;
  const userDoc = await getDoc(doc(db, 'users', user.uid));
  if (userDoc.exists()) return userDoc.data().companyId || null;
  return null;
};